import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import ProgressBar from "../components/ProgressBar";
import TooltipHelp from "../components/TooltipHelp";
import LoadingDataComponent from "../components/LoadingDataComponent";
import SaveAndContinueLater from "../components/SaveAndContinueLater";
import AutoCompleteAddress from "../components/AutoCompleteAddress";
import MessagePopup from "../components/MessagePopup";
import SectionHeader from "../components/SectionHeader";
import { IsFlowDeletedDialog } from "./WelcomePage";

const PermanentAddress = ({
  address,
  setAddress,
  streetNumber,
  setStreetNumber,
  postCode,
  setPostCode,
  city,
  setCity,
  countryCode,
  setCountryCode,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <TextField
        value={address}
        onChange={(event) => setAddress(event.target.value)}
        label={t("Street Name")}
        variant="standard"
        style={{ minWidth: "200px", width: "50%" }}
        InputLabelProps={{ required: false }}
        required
      />
      {"\u00A0\u00A0\u00A0"}
      <TextField
        value={streetNumber}
        onChange={(event) => setStreetNumber(event.target.value)}
        label={t("Number")}
        variant="standard"
        style={{ maxWidth: "25%" }}
        InputLabelProps={{ required: false }}
        required
      />
      <br />
      <TextField
        value={postCode}
        onChange={(event) => setPostCode(event.target.value)}
        label={t("Post Code")}
        variant="standard"
        style={{ minWidth: "150px", width: "25%" }}
        InputLabelProps={{ required: false }}
        required
      />
      {"\u00A0\u00A0\u00A0"}
      <TextField
        value={city}
        onChange={(event) => setCity(event.target.value)}
        label={t("City")}
        variant="standard"
        style={{ minWidth: "170px", width: "40%" }}
        InputLabelProps={{ required: false }}
        required
      />
      {"\u00A0\u00A0\u00A0"}
      <TextField
        value={countryCode}
        onChange={(event) => setCountryCode(event.target.value)}
        label={t("Country")}
        variant="standard"
        style={{ minWidth: "170px", width: "40%" }}
        InputLabelProps={{ required: false }}
        required
      />
    </div>
  );
};

const PhoneNumberBox = ({ phoneNumber, setPhoneNumber }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="p" color="black">
        {t("phone_number_paragraph")}
      </Typography>
      <br />
      <TextField
        value={phoneNumber}
        onChange={(event) => setPhoneNumber(event.target.value)}
        label={t("Phone Number")}
        variant="standard"
        style={{ minWidth: "200px", width: "50%" }}
        InputLabelProps={{ required: false }}
        required
      />{" "}
    </div>
  );
};

const ThirtyComponent = ({ thirty, setThirty }) => {
  const { t } = useTranslation();

  return (
    <div>
      <br />
      <br />
      <Typography variant="p" color="black">
        {t("do_you_have_30")}
      </Typography>
      <br />
      <Select
        value={thirty}
        onChange={(event) => setThirty(event.target.value)}
        label={t("do_you_have_30")}
        variant="filled"
        style={{ minWidth: "120px", width: "30%" }}
        required
      >
        <MenuItem value={"Yes"}>{t("yes")}</MenuItem>
        <MenuItem value={"No"}>{t("no")}</MenuItem>
        <MenuItem value={"dont_know"}>{t("dont_know")}</MenuItem>
      </Select>
    </div>
  );
};

const BioComponent = ({ bio, setBio }) => {
  const { t } = useTranslation();
  return (
    <div>
      <br />
      <br />
      <Typography variant="p" color="black">
        {t("bio_paragraph")} {"\u00A0\u00A0"}
        <TooltipHelp json_flag={"bio_tooltip"} />
      </Typography>
      <br />
      <br />
      <TextField
        value={bio}
        onChange={(event) => setBio(event.target.value)}
        style={{ minWidth: "320px", width: "90%" }}
        inputProps={{ maxLength: 700 }}
        rows={4}
        multiline
        variant="filled"
        required
      />
    </div>
  );
};

const AdditionalQuestions = ({ url, setShowLanguageSelection }) => {
  const [isDeleted, setIsDeleted] = useState(false);
  const [nameAgent, setNameAgent] = useState("");
  const [emailAgent, setEmailAgent] = useState("");

  const [searchParams] = useSearchParams();
  const properize_id = searchParams.get("properize_id");

  const [address, setAddress] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [postCode, setPostCode] = useState("");
  const [city, setCity] = useState("");
  const [countryCode, setCountryCode] = useState("");

  const [isExpat, setIsExpat] = useState(false);
  const [livedInNLBefore, setLivedInNLBefore] = useState(false);
  const [youAreInNLNow, setYouAreInNLNow] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [thirty, setThirty] = useState("");
  const [bio, setBio] = useState("");

  const [submitClicked, setSubmitClicked] = useState(false);
  const [nextStepLink, setNextStepLink] = useState(false);

  const [alreadyRendered, setAlreadyRendered] = useState(false);
  const [creditCheckCompleted, setCreditCheckCompleted] = useState(false);
  const [show30component, setShow30component] = useState(false);

  const [message, setMessage] = useState(false);

  const { t } = useTranslation();
  const { search } = useLocation();

  setShowLanguageSelection(true);

  useEffect(() => {
    const payload = {
      id: properize_id,
      database: "Tenants",
    };

    axios
      .post(
        url + "/get_data_from_airtable_table?step=additional_questions",
        payload
      )
      .then((response) => {
        setIsDeleted(response.data["ArchiveRemove"] === "2");
        setNameAgent(response.data["Name agent"]);
        setEmailAgent(response.data["Email agent"]);
        if (response.data["Flow type"] === "Netherlands") {
          setAddress(response.data["Current address"]);
          setStreetNumber(response.data["Current number"]);
          setPostCode(response.data["Current post code"]);
          setCity(response.data["Current city"]);
        }
        setCreditCheckCompleted(response.data["CheckC_Status"] === "Completed");
        setShow30component(
          ["Work", "Recently Changed Jobs", "Changing Jobs"].includes(
            response.data["WhatToDo"]
          )
        );
        setPhoneNumber(response.data["Mobile phone"]);
        setBio(response.data["Bio"]);
        setIsExpat(response.data["Flow type"] === "Expat");
        setThirty(response.data["30% ruling"]);

        setAlreadyRendered(true);

        const verifyIncome =
          !response.data["WhatToDo"] ||
          ["Work", "Self-employed", "Entrepreneur"].includes(response.data["WhatToDo"]) ||
          (response.data["Flow type"] !== "Expat" &&
            [
              "Recently Changed Jobs",
              "Self-employed",
              "Entrepreneur",
              "Subsidies",
            ].includes(response.data["WhatToDo"])) ||
          response.data["student_is_loan"] ||
          response.data["student_has_sidejob"];

        setNextStepLink(
          verifyIncome ? "income_verification" : "optional_information"
        );
      });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!address) {
      return setMessage(t("invalid_address"));
    }

    if ((streetNumber === "X" || !streetNumber) && (!isExpat || livedInNLBefore === "yes")) {
      return setMessage(t("no_number_in_address"));
    }

    setSubmitClicked(true);

    const payload = {
      properize_id: properize_id,
      address: address,
      housenumber: streetNumber,
      postcode: postCode,
      city: city,
      country_code: countryCode,
      lived_in_nl_before: livedInNLBefore === "yes",
      phoneNumber: phoneNumber,
      thirty: thirty,
      bio: bio,
      nextStep: nextStepLink,
    };

    axios
      .post(url + "/step3_api", payload, { timeout: 4000 })
      .then((response) => { window.location.assign("/" + nextStepLink + search) })
      .catch((err) => {
        window.location.assign("/" + nextStepLink + search);
      });
  };

  const ShowAdditionalQuestionsCompletedDialog = () => {
    return (
      <Dialog open={creditCheckCompleted === "Completed"}>
        <DialogContent>
          <DialogContentText>
            {t("additional_questions_was_completed")}
          </DialogContentText>
          <Grid container justifyContent="space-around" mt={5}>
            <Button
              variant="outlined"
              color="primary"
              style={{ width: "47%" }}
              onClick={() => setCreditCheckCompleted(false)}
            >
              {t("repeat")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ width: "47%" }}
              onClick={() =>
                window.location.assign("/" + nextStepLink + search)
              }
            >
              {t("next")}
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <div>
      <ProgressBar completed={70} />
      <br />
      <SectionHeader Icon={HomeOutlinedIcon} text={t("step_additional_info")} />
      <form onSubmit={handleSubmit}>
        {isExpat && (
          <div style={{ marginTop: "35px" }}>
            <Typography>
              {t("Have you lived in the Netherlands before?")}
            </Typography>

            <RadioGroup
              value={livedInNLBefore}
              onChange={(event) => setLivedInNLBefore(event.target.value)}
            >
              <FormControlLabel
                value="no"
                control={<Radio />}
                label={t("no")}
              />
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label={t("yes")}
              />
            </RadioGroup>

            {livedInNLBefore === "no" && (
              <div style={{ marginTop: "20px" }}>
                <Typography>
                  {t("Are you currently in the Netherlands?")}
                </Typography>

                <RadioGroup
                  value={youAreInNLNow}
                  onChange={(event) => setYouAreInNLNow(event.target.value)}
                >
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label={t("no")}
                  />
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label={t("yes")}
                  />
                </RadioGroup>
              </div>
            )}
          </div>
        )}
        {(!isExpat || livedInNLBefore === "yes" || youAreInNLNow !== false) && (
          <div
            style={{ minWidth: "320px", maxWidth: "800px", marginTop: "20px" }}
          >
            <Typography variant="p" color="black">
              {youAreInNLNow === "yes" && t("enter_current_address_in_NL")}
              {livedInNLBefore === "yes" &&
                youAreInNLNow !== "yes" &&
                t("enter_last_known_address_in_NL")}
              {(!isExpat ||
                (livedInNLBefore === "no" && youAreInNLNow === "no")) &&
                t("enter_current_address")}
            </Typography>
          </div>
        )}

        {((!isExpat || livedInNLBefore === "yes") || (isExpat && livedInNLBefore === "no" && youAreInNLNow === "yes")) && alreadyRendered && (
          <AutoCompleteAddress
            setStreet={setAddress}
            setHouseNumber={setStreetNumber}
            setPostCode={setPostCode}
            setCity={setCity}
            setCountryCode={setCountryCode}
            countryRestrictions={["nl"]}
          />
        )}

        {isExpat && livedInNLBefore === "no" && youAreInNLNow === "no" && (
          <PermanentAddress
            address={address}
            setAddress={setAddress}
            streetNumber={streetNumber}
            setStreetNumber={setStreetNumber}
            postCode={postCode}
            setPostCode={setPostCode}
            city={city}
            setCity={setCity}
            countryCode={countryCode}
            setCountryCode={setCountryCode}
          />
        )}
        <br />
        <br />
        <PhoneNumberBox
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
        />

        {show30component && (
          <ThirtyComponent thirty={thirty} setThirty={setThirty} />
        )}

        <BioComponent bio={bio} setBio={setBio} />

        <Grid container justifyContent="space-between" m={1} pt={1}>
          <Button
            variant="contained"
            type="submit"
            color="secondary"
            size="large"
            style={{
              minWidth: "320px",
              fontSize: "16px",
            }}
          >
            {!submitClicked && t("next")}
            {submitClicked && <CircularProgress />}
          </Button>
        </Grid>
      </form>
      <SaveAndContinueLater
        properize_id={properize_id}
        url={url}
        address={address}
        streetNumber={streetNumber}
        postCode={postCode}
        city={city}
        phoneNumber={phoneNumber}
        bio={bio}
      />
      <ShowAdditionalQuestionsCompletedDialog />
      <LoadingDataComponent alreadyRendered={alreadyRendered} />
      <MessagePopup state={message} setState={setMessage} message={message} />
      <IsFlowDeletedDialog isDeleted={isDeleted} nameAgent={nameAgent} emailAgent={emailAgent} />
    </div>
  );
};

export default AdditionalQuestions;
